import React, { Component } from 'react';
import { connect } from 'shalala';
import { Row, Col } from 'react-bootstrap';

import { useStore } from '../../store';
import EmisorCsdUpdate from './upsert/EmisorCsdUpdate';
import Loading from '../../facturotopia/loading/Loading';
import PageHeader from '../../support/page-header/PageHeader';

class EmisoresCsdUpdate extends Component {
  state = {};

  constructor(props) {
    super(props);

    const { id } = this.props.match.params;
    const { data = {} } = props.location.state || {};

    this.state = {
      data: !!data.id ? { ...data, series: data.series || [] } : { id },
    };

    const { data: emisor } = props.info;

    if (!data.rfc && emisor.rfc) {
      this.state = {
        data: {
          ...emisor,
        },
      };
    }
  }

  componentDidMount() {
    const { data } = this.state;

    if (!data.rfc) {
      this.props.history.replace('/app/emisores');
    } else if (!this.props.info.data || !this.props.info.data.rfc) {
      this.props.infoActions.setPartialState({ data });
    }
  }

  handleOnComplete = (data) => {
    this.props.history.replace('/app/emisores');
  };

  render() {
    const { data } = this.state;
    const { data: emisor, busy } = this.props.info;

    if (busy || !emisor.rfc) {
      return <Loading />;
    }

    return (
      <>
        <PageHeader
          text="Regresar"
          to={`/app/emisores/${emisor.id}/info`}
        />

        <Row>
          <Col
            md
            lg={8}
            className="pt-2"
          >
            <EmisorCsdUpdate
              data={!!emisor.rfc ? emisor : data}
              heading={
                <div>
                  <h5>Actualizar CSD</h5>

                  <div className="pt-2">Selecciona el nuevo CSD para "{emisor.razon_social}".</div>
                </div>
              }
              hint={
                <div className="pb-3">
                  Asegúrate de que el certificado pertenezca al RFC <strong>{emisor.rfc}</strong>
                </div>
              }
              onComplete={this.handleOnComplete}
            />
          </Col>
        </Row>
      </>
    );
  }
}

const mapState = (store) => {
  return { info: store.app.emisores.info };
};

const mapActions = (actions) => {
  return { infoActions: actions.app.emisores.info };
};

export default connect(useStore, mapState, mapActions)(EmisoresCsdUpdate);
